import React, { useEffect, useState } from 'react'
import TrackingTable from './TrackingTable'
import { swalError } from '../../../common/components/Swaler'
import UserTrackingSummary from './UserTrackingSummary'

type Props = {
  isActive: Boolean,
  isLoading: Boolean,
  getTrackingAlternatives: Function,
  fetchTracking: Function,
}

let intervalId

const CustomerTracking = ({ isActive, isLoading, getTrackingAlternatives, fetchTracking }: Props) => {
  const [query, setQuery] = useState('')
  const [alternatives, setAlternatives] = useState([])
  const [result, setResult] = useState({ customer: null, entries: [] })
  const [timeLeft, setTimeLeft] = useState(26)

  const fetchCustomerTracking = (id, search) =>
    fetchTracking('customers', id, search)
      .then((r) => setResult(r))
      .catch((e) => {
        if (e && e.response && e.response.status === 404) {
          swalError('Hittar ej användare')
        }
      })

  useEffect(() => {
    if (!isLoading && intervalId) {
      clearInterval(intervalId)
      intervalId = null
      setTimeLeft(26)
    }
    if (isLoading && !intervalId) {
      intervalId = setInterval(() => {
        setTimeLeft((prevValue) => prevValue - 1)
      }, 1000)
    }
  }, [isLoading])

  if (!isActive) return null

  return (
    <div>
      <h5>Skriv in användarens telefonnummer nedan</h5>
      <input type="text" value={query} onChange={(e) => setQuery(e.target.value)} />

      <button
        onClick={() => {
          const alts = getTrackingAlternatives('customers', { query })
          setAlternatives(alts)

          if (alts.length === 0) {
            fetchCustomerTracking(null, query)
          }
        }}
        className="Qbutton"
      >
        {isLoading ? <p>Laddar... ⏲️ ({timeLeft} s)</p> : 'Hämta loggar'}
      </button>

      <div className="flex" style={{ justifyContent: 'flex-start', marginTop: 10 }}>
        {alternatives.map((a) => (
          <button className="Qbutton" style={{ marginRight: 4 }} onClick={() => fetchCustomerTracking(a._id)} key={a._id}>{`${a.name} ${a.surname}, ${a.phone}`}</button>
        ))}
      </div>

      <h4>{result.customer && `Loggar för ${result.customer.name} ${result.customer.surname}`}</h4>
      {result.customer && <UserTrackingSummary user={result.customer} />}
      <TrackingTable isLoading={isLoading} data={result.entries} />
    </div>
  )
}

export default CustomerTracking
